import { generateRequest } from '.';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Ubi: {
    FetchQuoteUrlPending: 'FetchQuoteUrl_PENDING',
    FetchQuoteUrlCompleted: 'FetchQuoteUrl_FULFILLED',
    FetchQuoteUrlFailed: 'FetchQuoteUrl_FAILED',
  },
};

export const fetchQuoteUrl = (tripTakerGuid, emailVersion) => generateRequest({
  endpoint: `/assets-v2/api/ubi/quote?${toQueryString({ tripTakerGuid, emailVersion })}`,
  types: [
    Action.Ubi.FetchQuoteUrlPending,
    Action.Ubi.FetchQuoteUrlCompleted,
    Action.Ubi.FetchQuoteUrlFailed,
  ],
});
